//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  mixins: [parseTextMixin],
  props: {
    sku: { type: String, required: true },
    baseSku: { type: String, required: true },
    leMode: { type: Boolean, required: true },
    soldOut: { type: Boolean, required: true },
    showLandingPageLink: { type: Boolean, required: true }
  },
  computed: {
    showGiftWrap () {
      return this.$store.getters['product/isInStock']('gc_card') &&
        this.$flags.isActive('website.gifting.live') &&
        !this.$store.getters['cart/items'].some(item => item.sku.startsWith('giftwrap'))
    },
    limitedEditionProductConfig () {
      return this.$store.getters['product/limitedEditionProductConfig'](this.sku)
    },
    landingPage () {
      return this.limitedEditionProductConfig.landingPage || {}
    },
    linkCopy () {
      return this.limitedEditionProductConfig.landingPageLinkCopy || 'Learn More'
    },
    landingPageLink () {
      const productOnLandingPage = !!(this.landingPage.products || []).find(product => product.sku === this.sku)
      if (productOnLandingPage) return `/${this.landingPage.slug}/${this.sku}`
      return `/${this.landingPage.slug}`
    }
  }
}

// jQuery('.lens-polarise-toggle').toggleClass('active', jQuery('.lens-polarise-toggle input[type=checkbox]').prop('checked'))
